export default __webpack_public_path__ + "static/6. Seamless fee management 1-053ba1235a0831e477b221c490fcff9c.jpg";